import { get, post } from './api.js'

export function callGetEvents() {
  return get('/api/get-events')
}

export function callSendEmailPostPack(payload) {
  return post(`/api/auth/send-expo-post-pack-request-email`, payload)
}
